/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RequiresDiagnosis/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function RequiresDiagnosis({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/ActionsAction/Edit/Content/RequiresDiagnosis",
  onChange
  
}) {
let editRequiresDiagnosisValueData = fromData.useDataValue({ viewPath,
context: 'edit',
path: 'requires_diagnosis',
})
let editRequiresDiagnosisChangeData = fromData.useDataChange({ viewPath,
context: 'edit',
path: 'requires_diagnosis',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="edit.requires_diagnosis"
 value={editRequiresDiagnosisValueData}
 onChange={editRequiresDiagnosisChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Requires diagnosis"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}